function adjustDropdownHeight() {
    const dropdowns = document.querySelectorAll('.brand-select-list, .carrier-select-list, .device-select-list, .storage-select-list');
    const getEstimateButton = document.querySelector('#estimate-button')

    for (let x = 0; x < dropdowns.length; x += 1) {
        const dropdown = dropdowns[x]

        if (dropdown && getEstimateButton) {
            const buttonTop = getEstimateButton.getBoundingClientRect().top;
            const dropdownTop = dropdown.getBoundingClientRect().top;
    
            const maxHeight = buttonTop - dropdownTop;
            dropdown.style.maxHeight = maxHeight + 'px';
        }
    }
}

document.querySelectorAll('#mainBrandInput, #device-picker-input, #carrier-picker-input, #storage-picker-input').forEach(
    (item) => item.addEventListener('click', () => {
        setTimeout(adjustDropdownHeight, 10);
    }
))

window.addEventListener('resize', adjustDropdownHeight);